import { Box, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import theme from "../theme/theme";

function Content() {
  return (
    <Box
    id="home"
      sx={{
        marginTop:'15vh',


        width: "100%",
        height: {
          xs: "50vh",
          sm: "60vh",
          md: "70vh",
          lg: "90vh",
        },
        backgroundImage: `url("/home11.webp")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1,
        },
      }}
    >

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          padding: { xs: "10px", sm: "20px" },
          maxWidth: "80%",
        }}
      >
       <Typography
  variant="h3"
  sx={{
    fontWeight: 900,
    color: "white",
    fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem", lg: "3.5rem" },
    textShadow: "2px 2px 8px rgba(0,0,0,0.6)",
  }}
>
Start your journey here, at TAAL Travel & Visa
</Typography>


        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
            gap: 2,
            pt: 12,
            textAlign: "center",
          }}
        >
          <a
            href="https://api.whatsapp.com/send/?phone=971529635383"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <>
              <WhatsAppIcon
                sx={{
                  color: "white",
                  fontSize: "2.6rem",
                  padding: "0.5rem",
                  backgroundColor: "#25d366",
                  borderRadius: "50%",

                  border: "1px solid #25d366",
                  textAlign: "center",
                  transition: "0.5s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#00c6ff",
                  },
                }}
              />
            </>
          </a>

          <a
            href="https://www.instagram.com/taal_travel_visa/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <>
              <InstagramIcon
                sx={{
                  background:
                    "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                  borderRadius: "50%",
                  padding: "0.5rem",
                  fontSize: "2.6rem",
                  color: "white",
                  transition: "0.5s ease-in-out",
                  border: "1px solid #cc2366",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #00c6ff 0%, #0072ff 100%)",
                  },
                }}
              />
            </>
          </a>

          <a
            href="mailto:Tareq@taal-travel.com  "
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <>
              <EmailIcon
                sx={{
                  backgroundColor: "#ff0000",
                  borderRadius: "50%",
                  padding: "0.5rem",
                  fontSize: "2.6rem",
                  color: "white",
                  transition: "0.5s ease-in-out",
                  border: "1px solid #ff0000",
                  "&:hover": {
                    backgroundColor: theme.palette.secondary.main,
                  },
                }}
              />
            </>
          </a>
          <a
            href="tel:+971528918124"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <>
              <LocalPhoneRoundedIcon
                sx={{
                  backgroundColor: "#0077b5",
                  borderRadius: "50%",
                  padding: "0.5rem",
                  fontSize: "2.6rem",
                  color: "white",
                  transition: "0.5s ease-in-out",
                  border: "1px solid #0077b5",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              />
            </>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571096193365
"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <>
              <FacebookRoundedIcon
                sx={{
                  backgroundColor: "#3b5998",
                  borderRadius: "50%",
                  fontSize: "2.6rem",
                  color: "white",
                  padding: "0.5rem",
                  transition: "0.5s ease-in-out",
                  border: "1px solid #3b5998",
                  "&:hover": {
                    backgroundColor: theme.palette.secondary.main,
                  },
                }}
              />
            </>
          </a>
        </Box>
      </Box>
    </Box>
  );
}

export default Content;
